import { MenuItem } from "@chakra-ui/react";
import { TransactionCodesTable } from "features/fund-family/setup/fund/txcodes/TransactionCodesTable";
import { PermissionTypeEnum } from "gen/model/permissionTypeEnum";
import { useTranslation } from "react-i18next";
import { Restricted } from "shared/components/access/Restricted";
import { PageTabBody } from "shared/components/layout/PageTabBody";
import { RouteLink } from "shared/components/link/RouteLink";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxActionsMenu } from "shared/components/table/box/TableBoxActionsMenu";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import {
  MaybernTableBoxActions,
  TableExportButton,
} from "shared/components/table/maybern/MaybernTableBoxActions";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FundFamilySetupFundTabTransactionCodes = () => {
  const { t } = useTranslation(["fundFamily", "common"]);
  const { fundFamilyId } = useRequiredStringParams();
  return (
    <PageTabBody>
      <TableBox>
        <TableBoxHeader>
          <TableBoxTitle>
            {t("fundFamily:setup.transactionCodes.tableTitle")}
          </TableBoxTitle>
          <MaybernTableBoxActions
            showExpand={false}
            endChildren={
              <Restricted permission={PermissionTypeEnum.service}>
                <TableBoxActionsMenu>
                  <MenuItem
                    as={RouteLink}
                    to={
                      rootRoute({})
                        .fundFamilies({})
                        .fundFamily({ fundFamilyId })
                        .setup({})
                        .fund({})
                        .transactionCodesEdit({}).$
                    }
                  >
                    {t("common:edit")}
                  </MenuItem>
                </TableBoxActionsMenu>
              </Restricted>
            }
          >
            <TableExportButton />
          </MaybernTableBoxActions>
        </TableBoxHeader>
        <TableBoxBody>
          <TransactionCodesTable fundFamilyId={fundFamilyId} />
        </TableBoxBody>
      </TableBox>
    </PageTabBody>
  );
};
